var map = {
	"./sat_tokmak_desk.jpg": 4628,
	"./sat_tokmak_desk_dm.jpg": 6224,
	"./sat_tokmak_mob.jpg": 3361,
	"./sat_tokmak_mob_dm.jpg": 2611
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9966;